import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import { CartManager } from 'src/app/data/manager/cart/cart.manager';
import {SessionStorageManager} from 'src/app/data/manager/session-storage/session-storage.manager';
import {AlgoliaManager} from '../../data/manager/algolia/algolia.manager';
import {DepartmentManager} from '../../data/manager/department/department.manager';
import {HeaderDepartmentsService} from '../../ui/shared/utilities/header-departments-service/header-departments.service';

@Injectable({
  providedIn: 'root',
})
export class DepartmentsResponsiveVm {
  constructor(public algoliaManager: AlgoliaManager,
              private departments: DepartmentManager,
              private ssm: SessionStorageManager,
              private _headerDepartmentsService: HeaderDepartmentsService,
              private cartManager : CartManager) { }

  getDepartments(): Observable<any> {
    return this.departments.get();
  }

  setNavColor(categoryNav) {
    this.ssm.set('navColor', categoryNav);
  }

  setNavColorService(color: string) {
    this._headerDepartmentsService.sendColor(color);
  }

  sendEventTalonOne(data):Observable<any>{
    return this.cartManager.sendEventTalonOne(data)
  }
}
